
































































































import VueQrcode from 'vue-qrcode';
import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { _isEmpty, _filter } from '@samclick-lodash';
import { AuthorizationStore, CommonsStore } from '@samclick-store-factory';

class GetLinkDialogState {
  showDialog: boolean = false

  campaign: string | number = ''

  textLink: string = ''

  advertisementID: string | number = ''

  rowData: LooseObject = {}

  copiedKey: string = ""

}

class URLParams {
  public advertisementID: string = ''

  public affCode: string = ''

  public campaignID: string | number = ''

  public casinoID: Number = 0

  public landingPageID: string = ''
}

@Component({
  /**
    * Imported components
    * */
  components: { VueQrcode },
  /**
    * Stores values
    * */
  computed: {
    ...mapState({
      campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
    }),
  },
  /**
    * Component properties
    * */
  props: {},
})
export default class GetLinkDialog extends mixins(SamclickMixins) {
  /**
    * Local state
    * */
  state = new GetLinkDialogState();

  urlParams = new URLParams();

  API_URL = process.env.VUE_APP_BASE_API_URL;

  SamclickButton = new SamclickMixins().$data.SamclickButton

  TINY_URL = "https://tinyurl.com"

  campaignList!: []
  /**
    * Watchers
    * */
  @Watch('state.showDialog')
  dialogWatcher(newVal: string, oldVal: string) {
    if (oldVal && !newVal) {
      this.state = new GetLinkDialogState();
    }
  }

  /**
    * Methods
    * */
  toggleDialog(show: false, rowData: object = {}, advertisementID: string = '') {
    this.state.showDialog = show;
    this.state.rowData = rowData;
    this.state.advertisementID = advertisementID;
    this.state.textLink = this.$t('media.default_link').toString();

    const campaigns = this.getCampaignListBasedOnCategory();
    if (!_isEmpty(campaigns)) {
      this.state.campaign = campaigns[0].id;
    }
  }

  getCampaignListBasedOnCategory() {
    return this.campaignList;
  }

  getCasinoDescription(id: number) {
    return CommonsStore.casinoAllDescription(id) ? CommonsStore.casinoAllDescription(id).code : '';
  }

  getBaseLink({ affCode, campaignID, advertisementID, landingPageID }: URLParams) {
    let baseLink = `${this.API_URL}/go/redirect?bid=${advertisementID}&lid=${landingPageID}&aid=${affCode}&cid=${campaignID}`;

    if (this.state.rowData.isTinyURL) {
      baseLink = `${this.TINY_URL}/infiaff?bid=${advertisementID}&lid=${landingPageID}&aid=${affCode}&cid=${campaignID}`;
    }

    return baseLink;
  }

  get textLink() {
    const { id, casino_id } = this.state.rowData;
    const { campaign, advertisementID, textLink } = this.state;
    const affCode = AuthorizationStore.currentLoggedUserInState.affiliate_code;
    const campaigns = this.getCampaignListBasedOnCategory();
    if (this.state.advertisementID === '' || _isEmpty(campaigns)) {
      return '';
    }

    this.urlParams.advertisementID = advertisementID.toString()
    this.urlParams.affCode = affCode
    this.urlParams.campaignID = campaign
    this.urlParams.landingPageID = id
    this.urlParams.casinoID = casino_id

    const baseLink = this.getBaseLink(this.urlParams);

    return `<a href="${baseLink}" target="_blank">${textLink}</a>`;
  }

  get urlLink() {
    const { id, casino_id } = this.state.rowData;
    const { campaign, advertisementID } = this.state;
    const affCode = AuthorizationStore.currentLoggedUserInState.affiliate_code;
    const campaigns = this.getCampaignListBasedOnCategory();
    if (this.state.advertisementID === '' || _isEmpty(campaigns)) {
      return '';
    }

    this.urlParams.advertisementID = advertisementID.toString()
    this.urlParams.affCode = affCode
    this.urlParams.campaignID = campaign
    this.urlParams.landingPageID = id
    this.urlParams.casinoID = casino_id

    const baseLink = this.getBaseLink(this.urlParams);

    return baseLink;
  }

  get advertisementCategoryName() {
    const { advertisementCategoryId } = this.state.rowData;
    return CommonsStore.advertisementCategoryName(advertisementCategoryId);
  }

  get campaignListBasedOnCategory() {
    const { advertisementCategoryId } = this.state.rowData;
    return this.getCampaignListBasedOnCategory(advertisementCategoryId);
  }


  get dialogTitle() {
    return `${this.state.rowData.name} / ${this.getCasinoDescription(this.state.rowData.casinoId)}`;
  }

    async copyGeneratedCode(codeToCopy: string, key: string) {

        if (!codeToCopy || codeToCopy === this.$t('media.lbl_link_warning')) {
            return;
        }

        try {
            await navigator.clipboard.writeText(codeToCopy);

            // Show the tooltip
            this.state.copiedKey = key;

            // Hide it after 1.5 seconds
            setTimeout(() => {
                this.state.copiedKey = null;
            }, 1500);

        } catch (err) {
            console.error("Failed to copy code: ", err);
            this.state.copiedKey = null;
        }
    }

  /**
    * Computed
    * */


  /**
    * Lifecycle hooks
    * */
  created() {
  }

  mounted() {
  }

  beforeUpdate() {
  }
}
